export function mostraZero(decimals) {
  if (!decimals) {
    return;
  }
  return decimals.toFixed(2);
}
